import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useCallback, useEffect, useRef, useState } from "react";
import { setColumnWidth } from "../../../helpers/cookieUtils";
import ListingHeader from "../listingHeader/ListingHeader";
import {
  TableCellLayout,
  Popover,
  PopoverTrigger,
  PopoverSurface,
} from "@fluentui/react-components";
import {
  ArrowRepeatAllIcon,
  CloudArrowDownSvg,
  DocumentPDFSvg,
  DocumentTextSvg,
  MeatBallsMenuIcon,
} from "../../../modules/default-svg";
import userService from "../../../store/services/user.service";
import { generalActions } from "../../../store/actions";
import Spin from "../spinner/Spin";
import Modal from "../../../components/controls/modal/Modal";
import {
  clearMeetingReportRequest,
  meetingRegistoryRequest,
} from "../../../store/actions/meetings.actions";
import {
  meetingReport,
  meetingReportLoading,
} from "../../../store/selectors/meeting.selector";
import { useSelector } from "react-redux";
import moment from "moment";
import { compareArrays, sortColumnsByOrderlist } from "../../../helpers/utils";

const MeetingMinutesTable = (props) => {
  const {
    columnsList,
    rowData,
    searchHandler,
    tableName,
    handleColumnOrdering,
    dispatch,
    setPageNum,
    pagination,
    meetingsLoading,
    filterRegistry,
  } = props;
  const [cols, setCols] = useState([]);
  const [rows, setRows] = useState([]);
  const [tempFilteredRows, setTempFilteredRows] = useState(null);
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [setting] = useState(settings);
  const tableContainerRef = useRef(null);
  const lastScrollTop = useRef(0);
  const [editingHeader, setEditingHeader] = useState(null);
  const [headerValue, setHeaderValue] = useState("");
  const [columnSizing, setColumnSizing] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);
  const [sorting, setSorting] = useState([]);
  const getReport = useSelector(meetingReport);
  const getReportLoading = useSelector(meetingReportLoading);
  const [meetingActionType, setMeetingActionType] = useState("");
  const [showPDFModal, setShowPDFModal] = useState(false);
  const [pdfData, setPdfData] = useState("");
  const [pdfError, setPdfError] = useState("");
  const dateFormat = settings?.regionalSettings?.dateFormat;
  const timeFormat = settings?.regionalSettings?.timeFormat;
  const [popoverStates, setPopoverStates] = useState({});

  const handlePopoverChange = (itemId, isOpen) => {
    setPopoverStates( isOpen ? { [itemId]: isOpen } : {});
  };
  const [colsList, setColumnsList] = useState([]);
  useEffect(() => {
    if (columnsList.length) {
      setColumnsList(columnsList);
    }
  }, [columnsList]);
  const handlePreview = (item) => {
    setMeetingActionType("preview");
    setPdfError("");
    dispatch(clearMeetingReportRequest());
    var payload = {
      id: item.isRecurring
        ? item.occurenceId
          ? item.occurenceId
          : item.id
        : item?.id,
      isOccurrence: item.isRecurring,
      dates: item.isRecurring
        ? item.occurenceId
          ? null
          : {
              startTime: moment(item.startTime).format("YYYY-MM-DDTHH:mm"),
              endTime: moment(item.endTime).format("YYYY-MM-DDTHH:mm"),
            }
        : null,
    };
    dispatch(meetingRegistoryRequest(payload));
    setShowPDFModal(true);
  };

  const meetingRegistoryModalCloseHandler = () => {
    dispatch(clearMeetingReportRequest());
    setShowPDFModal(false);
    if (pdfData) {
      URL.revokeObjectURL(pdfData);
    }
    setPdfData("");
    setPdfError("");
    setMeetingActionType("");
  };

  const handleDownload = (item) => {
    setMeetingActionType("Download");
    var payload = {
      id: item.isRecurring
        ? item.occurenceId
          ? item.occurenceId
          : item.id
        : item?.id,
      isOccurrence: item.isRecurring,
      dates: item.isRecurring
        ? item.occurenceId
          ? null
          : {
              startTime: moment(item.startTime).format("YYYY-MM-DDTHH:mm"),
              endTime: moment(item.endTime).format("YYYY-MM-DDTHH:mm"),
            }
        : null,
    };
    dispatch(meetingRegistoryRequest(payload));
  };

  useEffect(() => {
    if (getReport && !getReportLoading) {
      try {
        if (!getReport || getReport.length === 0) {
          setPdfError("No PDF data received");
          return;
        }

        const pdfBlob = new Blob([getReport], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(pdfBlob);

        if (meetingActionType === "Download") {
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = "meeting-minute.pdf";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(blobUrl);
          setMeetingActionType("");
          return;
        }

        if (meetingActionType === "preview") {
          setPdfData(blobUrl);
          setMeetingActionType("");
        }
      } catch (error) {
        console.error("Error processing PDF data:", error);
        setPdfError("Error loading PDF data");
      }
    }
    if (!getReportLoading && !getReport && meetingActionType) {
      setPdfError("Failed to fetch PDF data");
    }
  }, [getReport, getReportLoading, meetingActionType]);

  // const modalBody = () => {
  //   if (pdfError) {
  //     return (
  //       <div
  //         style={{
  //           display: "flex",
  //           flexDirection: "column",
  //           justifyContent: "center",
  //           alignItems: "center",
  //           height: "100%",
  //           width: "100%",
  //         }}
  //       >
  //         <p style={{ color: "red", marginBottom: "10px" }}>
  //           Error: {pdfError}
  //         </p>
  //         <button
  //           onClick={() => {
  //             setPdfError("");
  //             // Retry logic if needed
  //           }}
  //         >
  //           Retry
  //         </button>
  //       </div>
  //     );
  //   }

  //   if (pdfData) {
  //     return (
  //       <iframe
  //         title="PDF Viewer"
  //         src={pdfData}
  //         width="100%"
  //         height="100%"
  //         style={{ border: "none" }}
  //       />
  //     );
  //   }

  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         height: "100%",
  //         width: "100%",
  //       }}
  //     >
  //       <Spin />
  //     </div>
  //   );
  // };

  const handleHeaderDoubleClick = (columnId, currentHeader) => {
    setEditingHeader(columnId);
    setHeaderValue(currentHeader);
  };

  const handleHeaderSave = (columnId) => {
    if (!headerValue.trim()) {
      dispatch(
        generalActions.showToast({
          title: "Header name cannot be empty",
          type: "error",
        })
      );
      return;
    }

    const updatedColumnsDB = cols.map((col) => ({
      name: col.Label,
      customName: col.accessorKey === columnId ? headerValue : col.CustomName,
      order: col.Order,
      isVisible: col.Visibility,
    }));

    const payload = {
      Name: tableName,
      Columns: updatedColumnsDB,
    };

    userService
      .putUserLayoutRequest(payload)
      .then(() => {})
      .catch(() => {
        dispatch(
          generalActions.showToast({
            title: "Error updating column header",
            type: "error",
          })
        );
      })
      .finally(() => {
        setColumnsList((prevCols) => {
          const newCols = prevCols.map((col) =>
            col.accessorKey === columnId
              ? { ...col, header: headerValue, customName: headerValue }
              : col
          );
          return newCols;
        });
      });

    setEditingHeader(null);
    setHeaderValue("");
  };

  const fetchMoreData = useCallback(() => {
    if (!pagination?.HasNext || meetingsLoading) return;
    setPageNum(pagination.CurrentPage + 1);
  }, [pagination, meetingsLoading]);

  const fetchMoreOnBottomReached = useCallback(
    (containerRefElement) => {
      if (containerRefElement && !meetingsLoading && pagination?.HasNext) {
        const { scrollHeight, scrollTop, clientHeight } = containerRefElement;
        const isVerticalScroll =
          Math.abs(scrollTop - lastScrollTop.current) > 5;
        lastScrollTop.current = scrollTop;

        if (isVerticalScroll && scrollHeight - scrollTop - clientHeight < 300) {
          fetchMoreData();
        }
      }
    },
    [fetchMoreData, meetingsLoading, pagination]
  );

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const handleScroll = () => fetchMoreOnBottomReached(container);
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, [fetchMoreOnBottomReached]);

  // Helper function to format date according to regional settings
  const formatDate = (dateString) =>
    moment(dateString).format(
      dateFormat
        ? dateFormat.replace(/dd/g, "DD").replace(/yy/g, "YY")
        : dateFormat
    );
  const formatTime = (dateString) =>
    moment(dateString).format(timeFormat === "hh:mm" ? "HH:mm" : "hh:mm a");

  const getSortingFunction = (col) => {
    switch (col.label) {
      case "Meeting Minutes":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.name || "").toLowerCase();
          const b = (rowB.original.name || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Date":
        return (rowA, rowB, columnId) => {
          const a = new Date(rowA.original.startTime || 0);
          const b = new Date(rowB.original.startTime || 0);
          return a.getTime() - b.getTime();
        };

      case "Meeting Owner":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.owner?.name || "").toLowerCase();
          const b = (rowB.original.owner?.name || "").toLowerCase();
          return a.localeCompare(b);
        };

      default:
        return "alphanumeric";
    }
  };

  const getSortDescFirst = (col) => {
    const descFirstColumns = ["Date"];
    return descFirstColumns.includes(col.label);
  };

  useEffect(() => {
    if (!colsList?.length && !rowData.length) return;
    const columnsOrder = colsList
      .filter((col) => col.isVisible !== false)
      .sort((a, b) => (a.order || 0) - (b.order || 0))
      .map((item) => item.accessorKey);
    setColumnOrder(columnsOrder);
    const columns = colsList
      .filter((col) => col.isVisible !== false)
      .sort((a, b) => (a.order || 0) - (b.order || 0))
      .map((col, index) => {
        return {
          Label: col.label,
          CustomName: col.customName,
          Order: col.order,
          Visibility: col.isVisible,
          accessorKey: col.accessorKey,
          header: col.header,
          enableHiding: true,
          enableColumnActions: false,
          grow: true,
          enableResizing: true,
          size: col.size,
          editVariant: col.columnType,
          enableGlobalFilter: true,
          enableSorting: editingHeader === col.accessorKey ? false : true,
          sortingFn: getSortingFunction(col),
          sortDescFirst: getSortDescFirst(col),
          Cell: ({ cell, row }) => {
            const item = row.original;
            switch (col.label) {
              case "Meeting Minutes":
                return (
                  <div className="flex justify-between items-center inputWidth">
                    <div className="flex items-center inputWidth">
                      <TableCellLayout className="text-truncate">
                        <div 
                          className="flex justify-center items-center cursor-pointer"
                          onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              handlePreview(item);
                              handlePopoverChange(
                                item.id,
                                !popoverStates[item.id]
                              );
                          }}
                        >
                          <span className="me-2">
                            <DocumentPDFSvg />
                          </span>
                          <span>{`MEETING MINUTES ${moment(
                            item.startTime
                          ).format("DDMMYY")} ${item.name}`}</span>
                          {item.isRecurring && (
                            <div style={{ maxWidth: "10%", marginLeft: "2px" }}>
                              <ArrowRepeatAllIcon />
                            </div>
                          )}
                        </div>
                      </TableCellLayout>

                      <div className="meatballs-trigger">
                        <Popover
                          open={popoverStates[item.id]}
                          onOpenChange={(e,data) => handlePopoverChange(item.id, data.open || false)}
                          positioning="below-start"
                        >
                          <PopoverTrigger disableButtonEnhancement>
                            <TableCellLayout
                              media={<MeatBallsMenuIcon />}
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handlePopoverChange(
                                  item.id,
                                  !popoverStates[item.id]
                                );
                              }}
                            />
                          </PopoverTrigger>
                          <PopoverSurface
                            tabIndex={-1}
                            className="listingPopoverWrapper"
                          >
                            <div className="listingPopoverContent">
                              <div
                                className="popItem"
                                onClick={() => {
                                  handlePreview(item);
                                  handlePopoverChange(
                                    item.id,
                                    !popoverStates[item.id]
                                  );
                                }}
                              >
                                <DocumentTextSvg />
                                <p className="text-sm-400 ms-12">Preview</p>
                              </div>
                              <div
                                className="popItem"
                                onClick={() => {
                                  handleDownload(item);
                                  handlePopoverChange(
                                    item.id,
                                    !popoverStates[item.id]
                                  );
                                }}
                              >
                                <CloudArrowDownSvg />
                                <p className="text-sm-400 ms-12">Download</p>
                              </div>
                            </div>
                          </PopoverSurface>
                        </Popover>
                      </div>
                    </div>
                  </div>
                );
              case "Date":
                if (!item.startTime) return "";

                // Format dates
                const startDateFormatted = formatDate(item.startTime);
                const endDateFormatted = formatDate(item.endTime);

                if (item.isAllDay) {
                  // For all-day events, just show the date(s)
                  // if (startDateFormatted === endDateFormatted) {
                  //   return startDateFormatted;
                  // } else {
                  //   return `${startDateFormatted} - ${endDateFormatted}`;
                  // }
                  const dateRange =
                    startDateFormatted === endDateFormatted
                      ? startDateFormatted
                      : `${startDateFormatted} - ${endDateFormatted}`;

                  return (
                    <div>
                      <div className="flex justify-center items-center">
                        <span>{dateRange}</span>
                        <span className="all-day-pill">All day</span>
                      </div>
                    </div>
                  );
                } else {
                  // For timed events, show date:time - date:time
                  const startTimeFormatted = formatTime(
                    item.startTime,
                    setting.regionalSettings.timeFormat
                  );
                  const endTimeFormatted = formatTime(
                    item.endTime,
                    setting.regionalSettings.timeFormat
                  );

                  if (startDateFormatted === endDateFormatted) {
                    return `${startDateFormatted}: ${startTimeFormatted} - ${endTimeFormatted}`;
                  } else {
                    return `${startDateFormatted}:${startTimeFormatted} - ${endDateFormatted}:${endTimeFormatted}`;
                  }
                }
              case "Meeting Owner":
                return item.owner.name;
              default:
                return cell.getValue();
            }
          },
          Header: ({ column }) => {
            return editingHeader === column.id ? (
              <input
                value={headerValue}
                onChange={(e) => setHeaderValue(e.target.value)}
                onBlur={() => handleHeaderSave(column.id)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleHeaderSave(column.id);
                  }
                }}
                autoFocus
                className="header-edit-input"
                style={{
                  minWidth: column.getSize() - 60,
                }}
              />
            ) : (
              <span>{column.columnDef.header}</span>
            );
          },
        };
      });
    setCols((prevCols) => {
      if (JSON.stringify(prevCols) !== JSON.stringify(columns)) {
        return columns;
      }
      return prevCols;
    });


    setRows(rowData);
  }, [colsList, rowData, editingHeader, headerValue]);

  const handleFilterMeetingRegistry = (value) => {
    if(!value)
      setTempFilteredRows(null);
    else
    setTempFilteredRows(rows.filter((meeting) =>`${moment( meeting.startTime ).format("DDMMYY")} ${meeting.name}`.toLowerCase().includes(value)));
  }
  
  const table = useMaterialReactTable({
    columns: cols,
    data: tempFilteredRows || rows,
    enableHiding: true,
    enableSorting: true,
    manualSorting: false,
    visibleInShowHideMenu: false,
    enablePagination: false,
    enableTopToolbar: true,
    enableGlobalFilter: true,
    enableStickyHeader: true,
    enableColumnFilterModes: true,
    enableColumnDragging: true,
    enableColumnOrdering: true,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    editDisplayMode: "cell",
    globalFilterFn: "contains",
    enableEditing: false,
    enableFilters: false,
    initialState: {
      density: "compact",
      showGlobalFilter: false,
      showColumnFilters: false,
      enableHiding: false,
      columnOrder: cols.map((col) => col.order),
    },
    state: {
      sorting,
      isLoading: meetingsLoading,
      columnSizing,
      columnOrder,
      showLoadingOverlay: false,
    },
    onSortingChange: setSorting,
    positionGlobalFilter: "left",
    onColumnSizingChange: (updater) => {
      setColumnSizing((prev) => {
        const newSizing =
          typeof updater === "function" ? updater(prev) : updater;
        Object.entries(newSizing).forEach(([columnId, width]) => {
          setColumnWidth(tableName, columnId, width);
        });
        return newSizing;
      });
    },
    onColumnOrderChange: (updater) => {
      const newOrder = typeof updater === "function" ? updater() : updater;
      const neworderList = newOrder
        .filter((item) => item !== "mrt-row-spacer")
        .filter(Boolean);
      const areEqual = compareArrays(neworderList, columnOrder);
      if (areEqual) {
        return newOrder;
      }

      const sortedColumns = sortColumnsByOrderlist(colsList, neworderList);
      handleColumnOrdering(sortedColumns);
      setColumnOrder(neworderList);
      return neworderList;
    },
    muiTableHeadCellProps: ({ column }) => ({
      sx: {
        fontFamily: "Figtree-Medium",
        fontSize: "14px",
        padding: "1rem 0.5rem 1rem 1rem",
        backgroundColor: "#f8f7fc",
        color:"#342c82",
        height: "40px",
        fontWeight: 600,
        "&:hover": {
          backgroundColor: "#ece8fd",
          "& .MuiDivider-root": {
            opacity: 1,
          },
          "& .MuiButtonBase-root": {
            opacity: 1,
          },
          fontWeight: 700,
        },
        position: "relative",
        "& .Mui-TableHeadCell-Content": {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          height: "100%",
        },
        "& .MuiTableSortLabel-root": {
          marginLeft: "8px",
          paddingTop: "3px",
          opacity: 0,
          "&:hover": {
            opacity: 1,
          },
        },
        "& .MuiDivider-root": {
          cursor: "col-resize",
          backgroundColor: "#342C82",
          opacity: 0,
        },
        "& .MuiButtonBase-root": {
          cursor: "grab",
          opacity: 0,
          "& .MuiSvgIcon-root": {
            path:{
              fill: "#342C82"
            }
          }
        },
      },
      onDoubleClick: (e) => {
        e.stopPropagation();
        e.preventDefault();
        handleHeaderDoubleClick(column.id, column.columnDef.header);
      },
    }),
    muiTopToolbarProps: {
      showColumnFilters: false,
      showGlobalFilter: true,
      enableHiding: false,
      sx: {
        position: "sticky",
        top: 0,
        zIndex: 1,
        "& .MuiBox-root": {
          padding: 0,
          display: "flex",
          alignItems: "center",
        },
      },
    },
    renderTopToolbar: () => (
      <ListingHeader
        parentType="Admin"
        isHeader={true}
        rightPane={true}
        type="MeetingRegistry"
        searchedData={searchHandler}
        setIsCreate={() => console.log(true)}
        filterRegistry={filterRegistry}
        isSearchDisable={cols.length}
        triggerSearch={handleFilterMeetingRegistry}
      />
    ),
    renderBottomToolbarCustomActions: () => (
      <div className="bottom-toolbar-container">
        <div className="toolbar-content">
          {meetingsLoading ? (
            <div className="loading-indicator">
              <span>Loading more data...</span>
            </div>
          ) : (
            <div className="data-info">
              <span className="data-text">
                Showing <strong>{rows.length}</strong> of{" "}
                <strong>{rows.length}</strong> total rows
              </span>
            </div>
          )}
        </div>
      </div>
    ),
    muiBottomToolbarProps: {
      sx: {
        position: "absolute",
        bottom: 0,
        backgroundColor: "#f8f7fc",
        padding: "0.7rem 1rem",
        width: "100%",
        height: "38px",
      },
    },
    muiTableBodyProps: {
      sx: {
        fontFamily: "Figtree-Regular",
        fontSize: "13px",

        marginBottom: "66px",
        "& .MuiTableBody-Cell": {
          "&:hover": {
            backgroundColor: "#ece8fd15",
          },
        },
      },
    },
    muiTableBodyRowProps: {
      sx: {
        height: "32px",
        position: "relative",
        "&:hover": {
          backgroundColor: "#ece8fd15",
        },
      },
      className: "hoverable-row",
    },
    muiTableContainerProps: ({ table }) => ({
      ref: tableContainerRef,
      sx: {
        height: `calc(100% - ${
          table.refs.topToolbarRef.current?.offsetHeight || 70
        }px)`,
        overflow: "auto",
        "&::-webkit-scrollbar": {
          height: "8px",
          width: "4px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#FFFFFF",
          borderRadius: "8px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#342c82",
          borderRadius: "8px",
          "&:hover": {
            backgroundColor: "#342c82",
          },
        },
      },
    }),
    muiTablePaperProps: {
      sx: {
        height: "100%",
      },
    },
    muiSkeletonProps: {
      height: 34,
      sx: {
        background:
          "linear-gradient(90deg, #e0e0e0 25%, #ECE7FD 50%, #e0e0e0 75%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s infinite",
        "@keyframes shimmer": {
          "0%": {
            backgroundPosition: "200% 0",
          },
          "100%": {
            backgroundPosition: "-200% 0",
          },
        },
      },
    },
    muiTableBodyCellProps: ({ cell, column, table }) => ({
      sx: {
        fontFamily: "Figtree-Regular",
        fontSize: "13px",
        padding: "0.5rem 1rem",
        position: "relative",
        overflow: "visible",
        "&:focus": {
          outline: "none",
        },
        "&:hover": {
          fontFamily: "Figtree-Medium",
          fontWeight: "bold",
        },
      },
    }),
    renderEmptyRowsFallback: () => {
      return meetingsLoading ? (
        <div className="d-flex justify-content-center">
          <Spin />
        </div>
      ) : rows.length === 0 ? (
        <div className="flex-grow flex items-center justify-center p-4">
          <div className="h-full flex flex-col items-center justify-center min-h-[400px] p-8">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="65"
              height="64"
              viewBox="0 0 65 64"
              fill="none"
              className="mb-4"
            >
              <path
                d="M6.9002 21.6008C6.9002 16.7407 10.8401 12.8008 15.7002 12.8008H49.3002C54.1603 12.8008 58.1002 16.7407 58.1002 21.6008V42.4008C58.1002 47.2609 54.1603 51.2008 49.3002 51.2008H32.8884L27.8968 46.2092C28.7964 44.3293 29.3002 42.2239 29.3002 40.0008C29.3002 32.0479 22.8531 25.6008 14.9002 25.6008C11.94 25.6008 9.18835 26.494 6.9002 28.0257V21.6008ZM14.9002 51.2008C17.416 51.2008 19.7381 50.3713 21.6079 48.9708L29.7688 57.132C30.3936 57.7569 31.4067 57.7569 32.0315 57.1321C32.6564 56.5072 32.6564 55.4942 32.0316 54.8693L23.8706 46.708C25.2708 44.8384 26.1002 42.5164 26.1002 40.0008C26.1002 33.8152 21.0858 28.8008 14.9002 28.8008C8.71461 28.8008 3.7002 33.8152 3.7002 40.0008C3.7002 46.1864 8.71461 51.2008 14.9002 51.2008ZM14.9002 48.0008C10.4819 48.0008 6.9002 44.4191 6.9002 40.0008C6.9002 35.5825 10.4819 32.0008 14.9002 32.0008C19.3185 32.0008 22.9002 35.5825 22.9002 40.0008C22.9002 44.4191 19.3185 48.0008 14.9002 48.0008Z"
                fill="#342C82"
              />
            </svg>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              No data currently available!
            </h3>
            <p className="text-gray-600 text-center max-w-md">
            New entries will appear here once created.
            </p>
          </div>
        </div>
      ) : null;
    },
  });

  if (showPDFModal) {
    return (
      <Modal
        title={`Meeting Minutes Report`}
        handleCancel={meetingRegistoryModalCloseHandler}
        body={
          pdfData && (
            <iframe
              title="PDF Viewer"
              src={pdfData}
              width="100%"
              height="100%"
            ></iframe>
          )
        }
        type={true}
        size=""
      />
    );
  }
  return <MaterialReactTable table={table} />;
};

export default MeetingMinutesTable;
